// extracted by mini-css-extract-plugin
export default {"modal__footer":"style_modal__footer__oVZ5Q","modal__footer__button_next":"style_modal__footer__button_next__On2N1","hidden":"style_hidden__o+Kzl"};